import React, { MouseEvent, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import Product from './Product';
import ButtonWithArrow from 'components/UI/Buttons/ButtonWithArrow/ButtonWithArrow';
import { pushGtmEvent } from 'services/gtm/gtmEvents';
import { getProductData } from 'services/gtm/gtmPageView';
import { formatAcpProduct } from 'services/gtm/gtmUtils';
import { Acp } from 'types/Acp';

import styles from './AutocompleteProducts.module.scss';

type Props = {
  className?: string;
  products?: Acp['products'];
  onClick?: (e: MouseEvent<HTMLAnchorElement>) => void;
  onClickSeeAll: (e: React.MouseEvent) => void;
};

export default function AutocompleteProducts({
  products,
  onClick,
  onClickSeeAll,
}: Props): JSX.Element {
  const { t } = useTranslation();
  const handleProductClick = useCallback(
    (
      product: Acp['products'][0],
      productIndex: number,
      e: MouseEvent<HTMLAnchorElement>
    ) => {
      pushGtmEvent({
        event: '_product_click',
        category: 'recherche',
        element: 'entrée de recherche',
        products: [
          getProductData(
            {
              ...formatAcpProduct(product),
              codeLibelleFamille: 'recherche',
              codeLibelleSsfamille: 'recherche',
              subuniverse: 'recherche',
              disponibilite: 'recherche',
              stickerOpeco: 'recherche',
            },
            productIndex + 1
          ),
        ],
      });

      onClick?.(e);
    },
    [onClick]
  );

  return (
    <div className={styles.container}>
      <div className={styles.products}>
        {products?.map((product, i) => (
          <Product
            key={product.id}
            product={product}
            onClick={e => handleProductClick(product, i, e)}
          />
        ))}
      </div>
      <div className={styles.seeAllButtonWrapper}>
        <ButtonWithArrow
          onClick={onClickSeeAll}
          model={'tertiary'}
          className={styles.seeAllButton}
        >
          {t('LABEL_SEE_ALL_RESULTS')}
        </ButtonWithArrow>
      </div>
    </div>
  );
}
